/***
*
*   APP LAYOUT
*   Main application layout containing the navigation
*   and header (title, secondary nav and signed in user)
*
*   PROPS
*   title: title of the view
*
**********/

import React, { Fragment, useContext, useEffect, useState } from 'react';
import { 
  AuthContext, 
  AppNav, 
  Button, 
  Quiz1, 
  Quiz2, 
  ActivityProgress,
  useAPI } from 'components/lib';
import axios from 'axios';
import ClassNames from 'classnames';
import Style from './app.module.scss';
import '../layout.scss'; // globals

export function AppLayout(props){

  const campaignList = useAPI('/api/user/campaign');
  const leadList = useAPI('/api/user/lead');

  const [onboard, setOnboard] = useState(null);
  const [hide, setHide] = useState(false);
  const [form, setForm] = useState({});

  // context & style
  const context = useContext(AuthContext);
  const css = ClassNames([ Style.app, 'with-sidebar' ]);

  async function getUser() {
    try {
      let res = await axios({

        method: 'GET',
        url: '/api/user',
        data: context.user.accounts[0].user_id
    
      });

      if(res.data.data && res.data.data.scope === null && res.data.data.target === null) {
        setOnboard('onboarding_1')
      }
      if(res.data.data && res.data.data.scope !== null && res.data.data.target === null) {
        setOnboard('onboarding_2')
      }
      if(res.data.data && res.data.data.scope !== null && res.data.data.target !== null) {
        setOnboard('onboarding_3')
        setHide(false);
      }

    } catch (err) {
      setOnboard('onboarding_1');
    }
  }

  const onLocalStorage = () => {
    setHide(true)
  }

  const formData = (data) => {
    let aux ={}
    if(data) {
      for(let key in data) {
        if(data[key]["value"]) {
          if(typeof data[key]["value"] === 'object') {
            aux[key] = data[key]
          } else {
            aux[key] = data[key]
          }
        }
      }
    }
    
    let obj = {...form, ...aux}

    setForm(obj)
  }

  const onOnboard = (ev) => {
    setOnboard(ev);
  }
  
  return (
    <Fragment>
      {!hide && onboard === 'onboarding_1' &&
        <Quiz1 onboard={onboard} setOnboard={onOnboard} formData={formData} btnShowAlert='show'/>
      }
      {!hide && onboard === 'onboarding_2' && 
        <Quiz2 onboard={onboard} setOnboard={setOnboard} formData={formData} btnShowAlert='show'/>
      }
      {!hide && onboard === 'onboarding_3' && campaignList && campaignList.data && leadList && leadList.data &&
        <ActivityProgress onboard={onboard} setOnboard={setOnboard} onLocalStorage={onLocalStorage} leadList={leadList.data} campaignList={campaignList.data} btnShowAlert='show'/>
      }
      <div className= {Style.notifications}>
        <div className={ Style['title-main'] }>
          Deal Finder
        </div>
        {!context?.user?.isEmailVerified || campaignList?.data?.length === 0 || leadList?.data?.length === 0 || !context?.user?.accounts[0]?.domain ?
          <div style={{width: '325px', height: '27px', marginTop: '4px', position: 'absolute', right: '0px'}}>
            <Button 
              text='No olvides completar tu información' 
              btnAlert 
              action={ e => getUser() }/>
          </div> : 
          <div/>
        }
      </div>
      <AppNav
        type='popup'
        items={[
          { label: 'Tablero Principal', icon: 'grid', link: '/dashboard' },
          { label: 'Deal Finder', icon: 'users', link: '/audience' },
          { label: 'Listas', icon: 'list', link: '/leads' },
          { label: 'Plantillas', icon: 'layout', link: '/templates' },
          { label: 'Campañas', icon: 'globe', link: '/campaign' },
          { label: 'Automatizaciones', icon: 'box', link: '/automation', disabled: true },
          { label: 'Verificación de Antecedentes', icon: 'box', link: '/background-check' },
          { label: 'Estadísticas', icon: 'bar-chart', link: '/statistics', disabled: true },
          { label: 'Cuenta', icon: 'user', link: '/account', },
          { label: 'Cerrar Sesión', icon: 'log-out', action: context?.signout }
        ]}
      />
      <main className={ css }>
        
        <h2 className='title-page'>{props.title}</h2>
        {/* <Header title={ props.title }>
          <User/>
        </Header> */}

        { <props.children {...props.data }/> }

      </main>
    </Fragment>
  );
}
